const setOtherBusinessType = (val = null) => {
  return {
    type: 'SET_OTHERBUSINESSTYPE',
    data: val,
  }
}

export default {
  setOtherBusinessType,
}
